import React from 'react';
import { useTranslation } from 'react-i18next';

const SubmitButton = ({ tkey, tkey_loading, id, className, loading, disabled, style, type = 'submit', onClick }) => {
  const { t } = useTranslation();
  const buttonText = loading ? t(tkey_loading || 'keys.waiting') : t(tkey || 'actions.save');

  return (
    <button type={type} className={className} id={id} disabled={disabled || loading} style={style} onClick={onClick}>
      {buttonText}
    </button>
  );
};

export default SubmitButton;
